export default "__VITE_ASSET__DOVei2Wd__"